// 按钮组件翻译
export default {
  // 基础操作按钮
  save: "保存",
  cancel: "取消",
  confirm: "确认",
  delete: "删除",
  edit: "编辑",
  create: "创建",
  add: "添加",
  remove: "移除",
  update: "更新",
  submit: "提交",
  reset: "重置",
  clear: "清空",
  search: "搜索",
  filter: "筛选",
  export: "导出",
  import: "导入",
  download: "下载",
  upload: "上传",
  copy: "复制",
  paste: "粘贴",
  close: "关闭",

  // 状态按钮
  loading: "加载中...",
  saving: "保存中...",
  deleting: "删除中...",
  uploading: "上传中...",
  downloading: "下载中...",
  processing: "处理中...",

  // 导航按钮
  back: "返回",
  next: "下一步",
  previous: "上一步",
  finish: "完成",
  continue: "继续",

  // 分页按钮
  firstPage: "首页",
  lastPage: "尾页",
  prevPage: "上一页",
  nextPage: "下一页",

  // 确认操作按钮
  yes: "是",
  no: "否",
  ok: "确定",
  apply: "应用",
  retry: "重试",
  refresh: "刷新",
  reload: "重新加载",
};
